import jwtDecode from 'jwt-decode';

function isTokenExpired(token) {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.exp * 1000 < Date.now();
  } catch (error) {
    return true; // Token is invalid or expired
  }
}
function getTokenData(token) {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (error) {
    return null; // Token is invalid or expired
  }
}

export const userRolesObj = {
  1: 'Digitelex User',
  2: 'Admin',
  3: 'Branch Manager',
  4: 'Godown Manager',
  5: 'Computer Operator',
  6: 'Collection Agent',
  7: 'Customer',
  8: 'Vendor',
};

function findMenuItemByLink(menuList, link) {
  for (const item of menuList) {
    if (item.link === link) {
      return item;
    }
    if (item.children) {
      const foundChild = findMenuItemByLink(item.children, link);
      if (foundChild) {
        return foundChild;
      }
    }
  }
  return null;
}

export { isTokenExpired, findMenuItemByLink, getTokenData };
